import { Outlet } from "react-router-dom";

const MainReceived = () => {
    return(
        <div className="w-full h-full">
            <Outlet/>
        </div>
    )
}
export default MainReceived;